<template>
  <div class="work_area">
    <div class="item">
      <div class="item_title">
        <p>
          <img src="../../../../static/img/icon3.png" alt="">
          <img src="../../../../static/img/icon2.png" alt="">
          <img src="../../../../static/img/icon1.png" alt="">
        </p>
        <span style="margin-top: -4px;">每月作业量</span>
      </div>
      <!-- <span class="danwei">单位：亩次</span> -->
    </div>
    <div id='workAreaEchart' style="width:99%;height:27vh;margin-top: -2.3vh;"></div>
  </div>
</template>
<script>
import  Api from '../../../Serves/net-api.js'
import Http from '../../../Serves/net-http.js'
import {mapState,mapActions,mapMutations} from "vuex";
export default {
  components:{
    
  },
  data(){
    return{
      workAreaEchart: '',
      yearValue: '',
      resultarr: [],
      arrWorkTypeName: [],
      arrs: [],
      arr1: [],
      arr2: [],
      arr3: [],
      arr4: [],
      tabDataList: []
    }
  },
  mounted(){
    setTimeout(() => {
      // this.countAreaByYear()
      this.statisticsNjNumAndWorkAreaByArea()
    }, 500)
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.workAreaEchart.resize()
      })
    })
  },
  methods:{
    statisticsNjNumAndWorkAreaByArea() {
      var parmse = {
        machineType: ''
      }
      var url = Http.test + '/homePageStatis/getNjnumAndWorkareaByMonth'
      Api.doPost(url, parmse, false, res => {
        this.tabDataList = res.result
        this.getdata(res.result)
      })
    },
    getdata(data) {
      var totalAreaArr = data.map(item => {
        return item.workArea
      })
      var nameArr = data.map(item => {
        return item.month
      })
      var totalArr = data.map(item => {
        return item.njNum
      })
      this.workAreaEchart = this.$echarts.init(document.getElementById('workAreaEchart'))
      this.workAreaEchart.setOption({
        // backgroundColor: '#0B1640',
        // tooltip: {
        //   trigger: 'axis',
        //   axisPointer: {
        //     type: 'cross',
        //     label: {
        //       backgroundColor: '#0B1640'
        //     }
        //   }
        // },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var relVal = '<div class="tooltipBox"><span">'+params[0].name+'</span>';
            for(var i = 0, l = params.length; i < l; i++) {
              let unit = params[i].seriesName == '作业面积' ? '亩次' : '台'
              relVal += '<br/> <span>' + params[i].marker+ params[i].seriesName + ' : ' + params[i].value + unit+'</span>'
            }
            relVal +='</div>'
            return relVal
          }
        },
        legend: {
          data: ['农机数量', '作业面积'],
          itemWidth: 15,
          itemHeight: 13,
          top: '2%', // 距离容器上边界40像素
          textStyle: {
            color: '#ffffff',
            fontSize: 14
          }
        },
        grid: {
          top: '22%', // 距离容器上边界40像素
          bottom: '18%', // 距离容器下边界30像素
          left: 60,
          right: 70,
        },
        dataZoom: [
          //X轴滑动条
          {
            type: 'slider', //滑动条
            // show: this.groupType === 1 ? true : false, //开启
            show: this.tabDataList.length > 15 ? true : false, //开启
            xAxisIndex: [0],
            left: '4%', //滑动条位置
            bottom: '2%',
            start: 0, //初始化时，滑动条宽度开始标度
            end: this.tabDataList.length > 15 ? 35 : 100 //初始化时，滑动条宽度结束标度
          },
          //X轴内置滑动
          {
            type: 'inside', //内置滑动，随鼠标滚轮展示
            xAxisIndex: [0],
            start: 1, //初始化时，滑动条宽度开始标度
            end: 100 //初始化时，滑动条宽度结束标度
          }
        ],
        xAxis: [{
          type: 'category',
          axisLabel: {
            color: '#fff',
            // fontSize: 14,
            rotate: 30
            // fontWeight: 'bold'
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#002CBD'
            },
            width: 5
          },
          axisTick: {
            show: false
          },
          data: nameArr.reverse()
          // data: ['山东省', '湖南省', '上海市', '北京市', '天津市', '福建省', '湖北省', '河北省', '河南省']
        }],
        yAxis: [
          {
            type: 'value',
            name: '机具数量（台）',
            position: 'left',
            nameTextStyle: {
              color: '#C8C7DD'
            },
            axisLabel: {
              show: true,
              color: '#C8C7DD',
              // formatter: '{value} 台'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#001E91'
              },
              width: 5
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                width: 0.2,
                type: 'dashed',
                color: '#002CBD'
              }
            }
          },
          {
            type: 'value',
            name: '作业面积（亩次）',
            // nameGap: '40',
            position: 'right',
            nameTextStyle: {
              color: '#C8C7DD'
            },
            axisLabel: {
              show: true,
              color: '#C8C7DD',
              // formatter: '{value} 亩'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#dddddd'
              },
              width: 5
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#001E91'
              }
            }
          }
        ],
        series: [{
            name: '农机数量',
            type: 'bar',
            barWidth: 25,
            color: "#007AFF",
            data: totalArr.reverse()
            // data: [2000.56, 33235, 45664, 4584, 8978, 1239, 45646, 4586, 74841]
          },
          {
            name: '作业面积',
            type: 'line',
            yAxisIndex: 1,
            color: '#2EDB00',
            data: totalAreaArr.reverse()
            // data: [123, 456, 231, 321, 213, 421, 623, 95, 100]
          }
        ]
      })
    }
  }
}
</script>
<style scoped>
  .work_area{
    width: 54%;
    height: 29vh;
    background-image: url(../../../../static/img/ng-bottom.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-right: 10px;
  }
  .item{
    /* height: 50px; */
    /* line-height: 50px; */
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    padding-top: 17px;
    position: relative;
  }
  .danwei{
     font-size: 14px;
    font-weight: 400;
    color: #81D4FF;
    line-height: 24px;
  }
  .item_title{
    display: flex;   
  }
 
  .item_title span{
    font-size: 0.9vw;
    font-weight: bold;
    color: #ffffff;
    font-family: '微软雅黑';
    margin-left: 10px;
  }
  .item_tab{
    width: 20%;
    height: 3.6vh;
    /* margin: 0 auto; */
    display: flex;
    margin-bottom: 10px;
    margin-top: 20px;
    border-radius: 0.6vw;
    background: #052293;
    position: absolute;
    top: -0.6vw;
    left: 13vw;
  }
  .item_tab span{
    width: 50%;
    /* text-align: center; */
    /* padding: 1vw; */
    display: inline-block;
    /* background: #052293; */
    text-align: center;
    line-height: 3.6vh;
    /* margin-top: 10px; */
    color: #ffffff;
    font-size: 1vw;
    cursor: pointer;
  }
  .item_tab span:nth-child(1){
    border-radius: 0.4vw 0 0 0.4vw;
  }
  .item_tab span:nth-child(2){
    border-radius: 0 0.4vw 0.4vw 0;
  }
  .active{
    color: #ffffff;
    font-weight: bold;
    background: #0b50e8;
  }
</style>




// WEBPACK FOOTER //
// src/components/Index/view/WorkArea.vue